import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
// Hooks
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import Form, { DashboardForm } from 'modules/reports/components/DashboardForm'
import type Dashboard from 'modules/reports/store/models/Dashboard'

type ModalProps = React.ComponentProps<typeof Modal>

interface Props {
  dashboard: Dashboard
  onClose: ModalProps['onClose']
}

const EditModal = ({ onClose, dashboard }: Props) => {
  const form = React.useMemo<DashboardForm>(() => new DashboardForm(dashboard.toJS()), [dashboard])

  const { running: isProcessing, performAction: onSubmit } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      const { success } = await asyncAction(() => form.save(dashboard), {
        successFlash: true,
        errorFlash: false,
      })

      if (success) closePortal()
    },
    {
      successFlash: false,
      errorFlash: false,
    }
  )

  return (
    <Modal
      illustration="user-interaction-review_chart"
      title={i18n.t('custom_reports.dashboard.modal.edit.title')}
      description={i18n.t('custom_reports.dashboard.modal.edit.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={() => onClose && onClose()}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={isProcessing || !form.isCompleted} submit>
            {i18n.t('common.edit')}
          </Button>
        </>
      }
    >
      <Form form={form} />
    </Modal>
  )
}

export default observer(EditModal)
